import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import EditProfileScreen from "./params/edit-profile.screen";
import PasswordSecurityScreen from "./params/password-security.screen";
import VerifyIdentityScreen from "./params/verify-identity.screen";

const MyaccountScreen = () => {

    const [renderComponent, setRenderComponent] = useState(null);
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const action = searchParams.get('action');
        let title = '';

        switch (action){
            case null:
                title = 'Edit Profile';
                setRenderComponent(<div className="hidden md:block"><EditProfileScreen /></div>);
                break;
            case 'edit_profile':
                title = 'Edit Profile';
                setRenderComponent(<EditProfileScreen />);
                break;
            case 'verify_account':
                title = 'Verify Identity';
                setRenderComponent(<VerifyIdentityScreen />);
                break;
            case 'password_security':
                title = 'Password & Security';
                setRenderComponent(<PasswordSecurityScreen />);
                break;
            default:
                setRenderComponent(<EditProfileScreen />)
                break;
        }
        // Set document title which triggers the MutationObserver in DashboardLayout
        document.title = title;
        // Scroll to top when action changes
        window.scrollTo(0, 0);
    }, [searchParams]);


    return(
        <> 
            {renderComponent}
        </>
    );
}

export default MyaccountScreen;